import type { editor } from "monaco-editor";

const WidgetId = "editor.widget.placeholderHint";

/**
 * Represents an placeholder renderer for monaco editor
 * Roughly based on
 * https://github.com/microsoft/vscode/blob/main/src/vs/workbench/contrib/codeEditor/browser/untitledTextEditorHint/untitledTextEditorHint.ts
 */
class MonacoEditorPlaceholderWidget implements editor.IContentWidget {
  private domNode: HTMLElement | undefined;
  private readonly editor: editor.ICodeEditor;
  private readonly placeholder: string;

  constructor(placeholder: string, editor: editor.ICodeEditor) {
    this.placeholder = placeholder;
    this.editor = editor;
    // register a listener for editor code changes
    editor.onDidChangeModelContent(() => this.onDidChangeModelContent());
    // ensure that on initial load the placeholder is shown
    this.onDidChangeModelContent();
  }

  private onDidChangeModelContent(): void {
    if (this.editor.getValue() === "") {
      this.editor.addContentWidget(this);
    } else {
      this.editor.removeContentWidget(this);
    }
  }

  getId(): string {
    return WidgetId;
  }

  getDomNode(): HTMLElement {
    if (!this.domNode) {
      this.domNode = document.createElement("div");
      this.domNode.style.width = "max-content";
      this.domNode.style.pointerEvents = "none";
      this.domNode.textContent = this.placeholder;
      this.domNode.style.color = "#A6A6A6";
      this.domNode.style.fontStyle = "italic";
      this.domNode.style.whiteSpace = "pre";
      this.editor.applyFontInfo(this.domNode);
    }
    return this.domNode;
  }

  getPosition(): editor.IContentWidgetPosition {
    return {
      position: { lineNumber: 1, column: 1 },
      preference: [monaco.editor.ContentWidgetPositionPreference.EXACT],
    };
  }

  dispose(): void {
    this.editor.removeContentWidget(this);
  }
}

export function addPlaceholderToMonacoEditor(placeholder: string, monaco: editor.IStandaloneCodeEditor): void {
  new MonacoEditorPlaceholderWidget(placeholder, monaco);
}
